import { cn } from "@/lib/utils"

/** Solid accent fill — use with tabs, icon buttons, CTAs on terra/violet background */
export const UI_ACCENT_FILLED = "bg-ui-accent text-ui-on-accent"

/** Sidebar nav item — base layout */
export const UI_NAV_ITEM_BASE = "mt-1 w-full rounded-lg px-2 py-2 text-left text-xs transition-colors"

/** Sidebar nav item — idle */
export const UI_NAV_ITEM_IDLE = "text-ui-text-secondary hover:bg-ui-surface-raised"

/** Sidebar nav item — active */
export const UI_NAV_ITEM_ACTIVE = "bg-ui-accent/25 dark:text-violet-100 light:text-ui-accent-text"

export function uiNavItemClass(active: boolean, extra?: string) {
  return cn(UI_NAV_ITEM_BASE, active ? UI_NAV_ITEM_ACTIVE : UI_NAV_ITEM_IDLE, extra)
}

/** List row with thumbnail — idle */
export const UI_LIST_ROW_IDLE = "border border-ui-border bg-ui-surface-raised hover:bg-ui-bg-elevated/[0.06]"

/** List row with thumbnail — active (border-based, no outer ring) */
export const UI_LIST_ROW_ACTIVE =
  "border border-ui-accent bg-ui-accent/25 dark:text-violet-100 light:text-ui-accent-text"

/** Selected list card — light: clay inset (nav-style), dark: violet tint */
export const UI_CARD_SELECTED =
  "dark:border-ui-accent dark:bg-violet-950/35 light:border-ui-border-strong light:bg-clay-2 light:shadow-[var(--shadow-clay-inset)] text-ui-text-primary"

/** Nested radio row inside a selected card */
export const UI_NESTED_SELECTED = "dark:bg-violet-900/40 light:bg-clay-3 text-ui-text-primary"

/** Strong selected tile (e.g. facing without reference) */
export const UI_TILE_SELECTED_STRONG =
  "border-2 border-ui-accent dark:bg-violet-950/90 dark:text-violet-50 light:bg-clay-2 light:text-ui-text-primary"

/** Selected tile ring (with reference preview) */
export const UI_TILE_SELECTED_RING = "border-2 border-ui-accent"

export const UI_CHOICE_CONTROL =
  "it2tv-choice-control shrink-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ui-focus-ring)] focus-visible:ring-offset-1"

export const UI_CHOICE_CONTROL_SM =
  "it2tv-choice-control it2tv-choice-control--sm shrink-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ui-focus-ring)] focus-visible:ring-offset-1"

export const UI_CHOICE_CONTROL_LG =
  "it2tv-choice-control it2tv-choice-control--lg shrink-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ui-focus-ring)] focus-visible:ring-offset-1"

/** Selected list card with softer border */
export const UI_CARD_SELECTED_SUBTLE =
  "border-ui-accent/40 dark:bg-violet-950/30 light:border-ui-border-strong light:bg-clay-2 light:shadow-[var(--shadow-clay-inset)] text-ui-text-primary"

/** Compact selected chip / panel */
export const UI_CHIP_SELECTED =
  "border-ui-accent/80 dark:bg-violet-950/90 dark:text-violet-100 light:border-ui-border-strong light:bg-clay-2 light:text-ui-text-primary light:shadow-[var(--shadow-clay-inset)]"
